import { saveAs } from 'file-saver';
import { useCallback } from 'react';

import entityContainerConnector from '~components/generic/entityContainerConnector';
import useAppSelector from '~hooks/useAppSelector';
import usePermissions from '~hooks/usePermissions';
import { shareFileCms } from '~services/api/calls/file';
import { getAbsoluteUrl } from '~store/getter';
import { selectConfigMyFilesEnabled } from '~store/selectors';
import { Asset } from './Asset';

type CmsAssetComponentProps = {
  data: Entity;
};

const CmsAssetComponent = ({ data }: CmsAssetComponentProps) => {
  const isSharingEnabled = useAppSelector(selectConfigMyFilesEnabled);
  const filename = data.attributes?.filename || '';
  const url = data.attributes.url ? getAbsoluteUrl(data.attributes.url) : null;

  const { hasViewMyFilesPermission } = usePermissions();

  const handleShare = useCallback(() => {
    if (isSharingEnabled && url) {
      shareFileCms(url);
    }
  }, [isSharingEnabled, url]);

  const handleDownload = useCallback(() => {
    if (url) {
      saveAs(url, filename);
    }
  }, [url, filename]);

  if (data) {
    return (
      <Asset
        showAddToMyFiles={hasViewMyFilesPermission}
        filename={filename}
        isSharingEnabled={isSharingEnabled}
        onShare={handleShare}
        onDownload={handleDownload}
      />
    );
  }
  return null;
};

export const CmsAsset = entityContainerConnector(CmsAssetComponent);
